import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  trophyContainer: {
    width: theme.spacing(3),
    marginRight: theme.spacing(1),
  },

  trophy: {
    width: theme.spacing(3),
  },

  prize: {
    color: theme.palette.success.light,
  },
}));
